import api, { reportApiError } from "../api";
import qs from "qs";
import includes from "lodash/includes";

export default {
  state: {
    vehicles: [],
    assets: [],
    cabinets: [],
    vehicle_types: [],
    vehicle_type: [],
    get_vehicles: [],
    cabinet_loaded: false,
  },
  getters: {
    getVehiclesData(state) {
      return state.vehicles;
    },
    getVehicleType(state) {
      return state.vehicle_type;
    },
    getVehicles(state) {
      return state.get_vehicles;
    },
    getCabinets(state) {
      return state.cabinets;
    },
    getCabinetLoaded(state) {
      return state.cabinet_loaded;
    },
  },
  mutations: {
    CLEAR_VEHICLE_TYPES_DATA(state) {
      state.vehicle_types.splice(0);
    },
    CLEAR_VEHICLE_TYPE(state) {
      state.vehicle_type.splice(0);
    },
    CLEAR_CABINETS(state) {
      state.cabinets.splice(0);
    },
    ADD_VEHICLE_TYPES_DATA(state, payload) {
      state.vehicle_types = payload;
    },
    ADD_VEHICLE_TYPE_DATA(state, payload) {
      state.vehicle_type = payload;
    },
    ADD_VEHICLES_DATA(state, data) {
      state.vehicles = data;
    },
    ADD_ASSETS_DATA(state, data) {
      state.assets = data;
    },
    ADD_VEHICLES(state, data) {
      state.get_vehicles = data;
    },
    ADD_CABINET_TO_LIST(state, cabinet) {
      state.cabinets.push(cabinet);
    },
    SET_CABINET_LOADED(state, loaded) {
      state.cabinet_loaded = loaded;
    },
  },
  actions: {
    LOAD_AVAILABLE_VEHICLES({ commit, rootState }, payloads) {
      const {
        origin,
        destination,
        start_date,
        end_date,
        find_shared,
      } = payloads;

      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_available_vehicles`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
            origin,
            destination,
            start_date,
            end_date,
            find_shared,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_VEHICLES_DATA", response.data.data);
          }
        })
        .catch((error) => {
          reportApiError(error, "get_available_vehicles");
          commit("ADD_VEHICLES_DATA", []);
        });
    },
    LOAD_AVAILABLE_ASSETS({ commit, rootState }, payloads) {
      const {
        origin,
        destination,
        start_date,
        end_date,
        find_shared,
        type,
      } = payloads;
      return api
        .post(
          `${process.env.VUE_APP_API_URL}/get_available_assets`,
          qs.stringify({
            token: rootState.token,
            clientid: rootState.clientid,
            origin,
            destination,
            start_date,
            end_date,
            find_shared,
            type,
          })
        )
        .then((response) => {
          if (response !== null) {
            commit("ADD_ASSETS_DATA", response.data.data);
          }
        })
        .catch((error) => {
          reportApiError(error, "get_available_assets");
          commit("ADD_ASSETS_DATA", []);
        });
    },
    LOAD_VEHICLE_TYPES({ commit, rootState }) {
      const { token, clientid } = rootState;
      const query = qs.stringify({ token, clientid });
      const url = `${process.env.VUE_APP_API_URL}/get_vehicles`;
      return api
        .post(url, query)
        .then((response) => {
          const vehicles = response.data.data;

          // Sentry CARPOOLING-R: get_vehicles can answer with a non-list even on
          // the success path, and .reduce() on it takes the whole page down.
          if (!Array.isArray(vehicles)) {
            reportApiError(
              new Error(`get_vehicles returned ${typeof vehicles}, expected array`),
              "get_vehicles"
            );
            commit("ADD_VEHICLE_TYPES_DATA", []);
            commit("ADD_VEHICLES", []);
            return;
          }

          const vehicle_types = vehicles.reduce((arr, vehicle) => {
            if (includes(arr, vehicle.type_name) == false)
              arr.push(vehicle.type_name);
            return arr;
          }, []);
          commit("ADD_VEHICLE_TYPES_DATA", vehicle_types);
          commit("ADD_VEHICLES", vehicles);
        })
        .catch((error) => {
          reportApiError(error, "get_vehicles");
          commit("ADD_VEHICLE_TYPES_DATA", []);
          commit("ADD_VEHICLES", []);
        });
    },
    LOAD_VEHICLE_TYPE({ commit, rootState }) {
      const { token, clientid } = rootState;
      const query = qs.stringify({ token, clientid });
      const url = `${process.env.VUE_APP_API_URL}/get_vehicle_types`;
      return api
        .post(url, query)
        .then((response) => {
          commit("ADD_VEHICLE_TYPE_DATA", response.data.data);
        })
        .catch((error) => {
          reportApiError(error, "get_vehicle_types");
          commit("ADD_VEHICLE_TYPE_DATA", []);
        });
    },
    LOAD_CABINETS({ commit, rootState }) {
      const { token } = rootState;
      const query = qs.stringify({ token });
      const url = `${process.env.VUE_APP_API_URL}/get_cabinets`;
      return api
        .post(url, query)
        .then((response) => {
          commit('SET_CABINET_LOADED', true);
          const { cabinets } = response.data.data || {};
          if (!Array.isArray(cabinets)) return;
          cabinets.forEach((cabinet) => {
            commit('ADD_CABINET_TO_LIST', cabinet);
          });
        })
        .catch((error) => {
          reportApiError(error, "get_cabinets");
          commit('SET_CABINET_LOADED', true);
        });
    },
  },
};
